// extracted by mini-css-extract-plugin
module.exports = {"difficultyIcon":"style-module__difficultyIcon___2mzFJ"};